<template>
    <KRHPPaigutus lehePealkiri="Teavitused/Pöördumised" portaaliPealkiri="Kriminaalhooldusportaal">
        <template #body>
            <v-container class="ma-2 pa-2"></v-container>
            <v-row>
                <v-col >                    
                    <h3>Vastuvõetud</h3>
                    <v-table>
                        <thead>
                            <tr>
                                <th class="text-left">
                                    Kuupäev
                                </th>
                                <th class="text-left">
                                    Kellaeg
                                </th>
                                <th class="text-left">
                                    Teema
                                </th>
                                <th class="text-left">
                                    Sisu eelvaade
                                </th>
                                <th class="text-left">
                                    Manused
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </v-table>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <h3>Saadetud</h3>
                    <v-table>
                        <thead>
                            <tr>
                                <th class="text-left">
                                    Kuupäev
                                </th>
                                <th class="text-left">
                                    Kellaeg
                                </th>
                                <th class="text-left">
                                    Teema
                                </th>
                                <th class="text-left">
                                    Sisu eelvaade
                                </th>
                                <th class="text-left">
                                    Manused
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </v-table>
                </v-col>
            </v-row>
        </template>
    </KRHPPaigutus>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import KRHPPaigutus from './uldine/KRHPPaigutus.vue';

export default defineComponent({
    name: 'SuhtlusAmetnikuga',
    components: { KRHPPaigutus },
});
</script>

<style scoped></style>